import _defineProperty from "/workdir/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import React, { useState, useCallback, useEffect, useContext } from 'react';
import { Box } from '@hub/box';
import { Cluster, ClusterItem } from '@hub/cluster';
import { CoreContainer } from '@hub/core-container';
import { Stack } from '@hub/stack';
import { Tabs } from '@hub/tabs';
import useIsMounted from '../../hooks/use-is-mounted';
import Account from '../../components/universal-header/nav/account';
import { getAlgoliaApiKeys } from '../../config';
import Search from '../../components/search';
import analyticsUtils from '../../helpers/analytics-utils';
import trackClickEvent from '../../helpers/analytics-utils/track-event';
import RegisterRedirect from '../../helpers/register-redirect';
import { FeatureFlagsContext } from '../../context';
import { HamburgerButton } from './hamburger-button';
import { HamburgerMenu } from './hamburger-menu';
import { UniversalHeaderLogos } from './universal-header-logos';
import { SearchButton } from './search-button';
import { AccountPane } from './account-pane';
import { UniversalHeaderTabs } from './tabs';
import { Cart, CartVariant } from './cart';
import { HeaderTabs } from './tabs/header-tabs';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export * from './use-universal-header';
export * from './use-universal-header/fetch-universal-header-static-data';
export const toggleScroll = isMenuOpen => {
  if (isMenuOpen) {
    document.body.style.overflow = 'hidden';
  } else {
    document.body.style.removeProperty('overflow');
  }
};
export const UniversalHeader = _ref => {
  let {
    logo,
    hasBottomMargin = true,
    hamburgerMenuProps,
    searchProps,
    headerTabsProps,
    navPath,
    user,
    logoUrl,
    country,
    directCategories
  } = _ref;
  const {
    0: isHamburgerMenuOpen,
    1: setIsHamburgerMenuOpen
  } = useState(false);
  const {
    0: hamburgerMenuPath,
    1: setHamburgerMenuPath
  } = useState(navPath);
  const isLoggedIn = Boolean(user);
  const isMounted = useIsMounted();
  const openHamburgerMenuAtPath = useCallback(path => {
    toggleScroll(true);
    setIsHamburgerMenuOpen(true);
    setHamburgerMenuPath(path !== null && path !== void 0 ? path : []);
  }, []);
  const closeNav = useCallback(() => {
    toggleScroll(false);
    setIsHamburgerMenuOpen(false);
  }, []);
  const {
    0: isAccountPaneOpen,
    1: setIsAccount
  } = useState(false);
  const displayAccountNav = useCallback(displayNav => {
    trackClickEvent(analyticsUtils.categories.UNIVERSAL_HEADER, displayNav ? analyticsUtils.actions.UNIVERSAL_HEADER_NAV_MENU_OPEN : analyticsUtils.actions.UNIVERSAL_HEADER_NAV_MENU_CLOSE, analyticsUtils.labels.ACCOUNT_ICON);

    if (displayNav && !isLoggedIn) {
      RegisterRedirect();
      return;
    }

    toggleScroll(displayNav);
    setIsAccount(displayNav);
  }, [isLoggedIn]);
  const {
    NEXT_PUBLIC_FEAT_FLAG_CART_PREVIEW: isCartPreviewEnabled
  } = useContext(FeatureFlagsContext);
  useEffect(() => {
    if (navPath) {
      openHamburgerMenuAtPath(navPath);
    }
  }, [navPath, openHamburgerMenuAtPath]); // The 'order' below is not a magic number, it's an ordinal, and I can't tell
  // the eslint rule to respect ordinals, so I have to turn it off.

  /* eslint-disable no-magic-numbers */

  return /*#__PURE__*/_jsxs(Tabs, _objectSpread(_objectSpread({
    variant: "unstyled"
  }, hasBottomMargin && {
    sx: {
      marginBottom: ['spacing-md', null, 'spacing-lg']
    }
  }), {}, {
    "data-id": "universal-header_index_UniversalHeader_Tabs",
    children: [/*#__PURE__*/_jsxs(Stack, {
      shouldWrapChildren: false,
      "data-id": "universal-header_index_UniversalHeader_Tabs_Stack",
      children: [/*#__PURE__*/_jsx(CoreContainer, {
        sx: {
          minHeight: ['size-12', 'size-12', 'size-9'],
          display: 'flex',
          justifyContent: 'space-between'
        },
        "data-id": "universal-header_index_UniversalHeader_Stack_CoreContainer",
        children: /*#__PURE__*/_jsxs(Cluster, {
          align: "flex-end",
          gapX: "spacing-md",
          sx: {
            flexGrow: 1
          },
          "data-id": "universal-header_index_UniversalHeader_CoreContainer_Cluster",
          children: [/*#__PURE__*/_jsx(HamburgerButton, {
            expanded: isHamburgerMenuOpen,
            menuId: "universal-header-hamburger-menu",
            sx: {
              alignSelf: 'flex-end',
              order: [6, 6, 1],
              marginBottom: ['spacing-sm', 0],
              marginTop: ['spacing-xs', 0]
            },
            onToggle: () => openHamburgerMenuAtPath(),
            "data-id": "universal-header_index_UniversalHeader_Cluster_HamburgerButton"
          }), /*#__PURE__*/_jsx(Box, {
            sx: {
              alignSelf: 'flex-end',
              order: [1, 1, 2],
              marginBottom: ['spacing-md', 'spacing-sm'],
              marginTop: ['spacing-xs', null]
            },
            "data-id": "universal-header_index_UniversalHeader_Cluster_Box",
            children: /*#__PURE__*/_jsx(UniversalHeaderLogos, {
              logo: logo,
              boxSize: "size-icon-line-height-base",
              url: logoUrl,
              sx: {
                paddingBottom: ['spacing-md', 0]
              },
              "data-id": "universal-header_index_UniversalHeader_Box_UniversalHeaderLogos"
            })
          }), /*#__PURE__*/_jsx(ClusterItem, {
            sx: {
              alignSelf: 'flex-end',
              order: [7, 7, 3]
            },
            width: ['100%', null, 'auto'],
            "data-id": "universal-header_index_UniversalHeader_Cluster_ClusterItem",
            children: /*#__PURE__*/_jsx(HeaderTabs, {
              country: country,
              tabsProps: headerTabsProps,
              sx: {
                marginLeft: ['-24px', null, 0],
                marginRight: ['-24px', null, 0]
              },
              "data-id": "universal-header_index_UniversalHeader_ClusterItem_HeaderTabs"
            })
          }), /*#__PURE__*/_jsx(Box, {
            sx: {
              flexGrow: 1,
              order: [2, 2, 4]
            },
            "data-id": "universal-header_index_UniversalHeader_Cluster_Box"
          }), /*#__PURE__*/_jsx(Search, {
            country: country,
            centre: headerTabsProps.centre,
            algoliaApiKeys: getAlgoliaApiKeys(),
            directCategories: directCategories,
            "data-id": "universal-header_index_UniversalHeader_Cluster_Search",
            children: showSearch => isMounted ? /*#__PURE__*/_jsx(SearchButton, _objectSpread(_objectSpread({}, searchProps), {}, {
              country: country,
              centre: headerTabsProps.centre,
              sx: {
                alignSelf: 'flex-end',
                marginBottom: ['spacing-md', 'spacing-sm'],
                marginTop: ['spacing-xs', null],
                order: [3, 3, 5],
                position: 'relative',
                top: [null, null, '-4px']
              },
              controlledElementId: "universal-search-modal",
              onClick: showSearch,
              "data-id": "universal-header_index_UniversalHeader_SearchButton"
            })) : /*#__PURE__*/_jsx(_Fragment, {})
          }), country === 'Australia' && isMounted && /*#__PURE__*/_jsxs(_Fragment, {
            children: [/*#__PURE__*/_jsx(AccountPane, {
              isLoggedIn: isLoggedIn,
              name: user === null || user === void 0 ? void 0 : user.firstName,
              displayAccountNav: displayAccountNav,
              sx: {
                alignSelf: 'flex-end',
                marginBottom: ['spacing-md', 'spacing-sm'],
                marginTop: ['spacing-xs', null],
                order: [4, 4, 6]
              },
              "data-id": "universal-header_index_UniversalHeader_AccountPane"
            }), isCartPreviewEnabled ? /*#__PURE__*/_jsx(CartVariant, {
              sx: {
                order: [5, 5, 6],
                alignSelf: 'flex-end',
                marginBottom: ['spacing-md', 'spacing-sm'],
                marginTop: ['spacing-xs', null]
              },
              "data-id": "universal-header_index_UniversalHeader_CartVariant"
            }) : /*#__PURE__*/_jsx(Cart, {
              sx: {
                order: [5, 5, 6],
                alignSelf: 'flex-end',
                marginBottom: ['spacing-md', 'spacing-sm'],
                marginTop: ['spacing-xs', null]
              },
              "data-id": "universal-header_index_UniversalHeader_Cart"
            })]
          })]
        })
      }), /*#__PURE__*/_jsx(UniversalHeaderTabs, _objectSpread(_objectSpread({}, headerTabsProps), {}, {
        openHamburgerMenuAtPath: openHamburgerMenuAtPath,
        "data-id": "universal-header_index_UniversalHeader_Stack_UniversalHeaderTabs"
      }))]
    }), isHamburgerMenuOpen && /*#__PURE__*/_jsx(HamburgerMenu, _objectSpread(_objectSpread({}, hamburgerMenuProps), {}, {
      menuId: "universal-header-hamburger-menu",
      initialPath: hamburgerMenuPath,
      onClose: () => {
        var _hamburgerMenuProps$o;

        closeNav();
        (_hamburgerMenuProps$o = hamburgerMenuProps.onClose) === null || _hamburgerMenuProps$o === void 0 ? void 0 : _hamburgerMenuProps$o.call(hamburgerMenuProps);
      },
      "data-id": "universal-header_index_UniversalHeader_HamburgerMenu"
    })), isAccountPaneOpen && isLoggedIn && /*#__PURE__*/_jsx(Account, {
      user: user,
      onClose: () => displayAccountNav(false),
      "data-id": "universal-header_index_UniversalHeader_Account"
    })]
  }));
  /* eslint-enable no-magic-numbers */
};